import React, { useEffect } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useTranslation } from "react-i18next";
type MortageRefinancingCalculatorProps = RouteComponentProps<{}>;

const MortageRefinancingCalculator: React.FunctionComponent<MortageRefinancingCalculatorProps> = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    function handleSubmit(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page">{tLang("resourcesSection.calculator.label.mortageRefinancingCalculator")} </h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="table-container scroll">
                            <div id="calc-body">
                                <div id="container_outer">
                                    <div>
                                        <Link id="close" to="/resources/calculators">
                                            X
                                        </Link>
                                    </div>

                                    <div className="calc_container">
                                        <div className="calc_contents long">
                                            <div className="calc_description">
                                                <h3 className="financial" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                                    Mortage Refinancing Calculator
                                                </h3>
                                                <p>
                                                    <strong>
                                                        This calculator will help you to decide whether or not you should refinance your current mortgage at a lower
                                                        interest rate.
                                                    </strong>
                                                </p>
                                                <p>
                                                    Not only will this calculator calculate the monthly payment and net interest savings, but it will also calculate
                                                    how many months it will take to break even on the closing costs.
                                                </p>
                                            </div>

                                            <form onSubmit={(e) => handleSubmit(e)}>
                                                <table className="calculator mort2" cellSpacing="0" cellPadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <strong id="principalLabel">
                                                                    Enter the principal balance of your mortgage:
                                                                    <br />
                                                                    <span className="note2">(call your mortgage lender and ask for the current payoff amount)</span>
                                                                </strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="principal" id="principal" aria-labelledby="principalLabel" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="paymentLabel">Enter the amount of your monthly mortgage payment (Principal &amp; Interest Only):</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="payment" id="payment" aria-labelledby="paymentLabel" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="intRateLabel">Enter your mortgage's current interest rate:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="intRate" id="intRate" aria-labelledby="intRateLabel" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="intRate2Label">Enter interest rate you will be refinancing at:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="intRate2" id="intRate2" aria-labelledby="intRate2Label" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id='nper2Label'>Enter the number of years you will be refinancing for:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="nper2" id="nper2" aria-labelledby="nper2Label" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="closingCostLabel">
                                                                    Enter the closing costs &nbsp;&nbsp;
                                                                    <select
                                                                        name="ptsDol"
                                                                        id="ptsDol"
                                                                        aria-labelledby="ptsDol"
                                                                        size={1}
                                                                        style={{ width: "16em", height: "2em" }}
                                                                    >
                                                                        <option value="points">percentage points</option>
                                                                        <option value="dollar">dollar amount</option>
                                                                    </select>{" "}
                                                                    :<br />
                                                                    <br />
                                                                    <span className="note2">
                                                                        (Typically, # of points is "2" or dollar amount is .02 times the principal)
                                                                    </span>
                                                                </strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="closingCost" id="closingCost" aria-labelledby="closingCostLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="yesNoLabel">Would you like to finance the closing costs?</strong>
                                                            </td>
                                                            <td>
                                                                <select name="yesNo" id="yesNo" aria-labelledby="yesNoLabel" size={1} style={{ width: "5em" }}>
                                                                    <option value="No">No</option>
                                                                    <option value="Yes">Yes</option>
                                                                </select>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={2} align="right">
                                                                <input
                                                                    className="debt_textbtn"
                                                                    type="submit"
                                                                    value="Compute"
                                                                    onClick={(e) => window.computeForm(e)}
                                                                    style={{ width: "85px" }}
                                                                />
                                                                <input className="debt_textbtn" type="reset" value="Reset" style={{ width: "62px" }} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td className="calc_divider">
                                                                <strong id="payment2Label">This is how much your monthly payment will be if you refinance:</strong>
                                                            </td>
                                                            <td className="calc_divider">
                                                                <input type="text" name="payment2" id="payment2" aria-labelledby="payment2Label" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="moSaveLabel">Monthly Payment Reduction:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="moSave" id="moSave" aria-labelledby="moSaveLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="closeMoLabel"># of months for interest savings to offset closing costs:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="closeMo" id="closeMo" aria-labelledby="closeMoLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="origIntLabel">This is how much interest you will pay under your current monthly payment plan:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="origInt" id="origInt" aria-labelledby="origIntLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="totInt2Label">This is how much interest you will pay under your refinanced monthly payment plan:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="totInt2" id="totInt2" aria-labelledby="totInt2Label" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="intSaveLabel">This is how much interest you will save if you refinance:</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="intSave" id="intSave" aria-labelledby="intSaveLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <strong id="netSaveLabel">Net Refinancing Savings (interest savings less closing costs):</strong>
                                                            </td>
                                                            <td>
                                                                <input type="text" name="netSave" id="netSave" aria-labelledby="netSaveLabel" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={2}>
                                                                <label htmlFor="summary" className="hide-label">summary</label>
                                                                <strong>
                                                                    <textarea
                                                                        cols={60}
                                                                        rows={8}
                                                                        name="summary"
                                                                        id="summary"
                                                                        wrap="virtual"
                                                                    ></textarea>
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Helmet>
                <script src="js/MortageRefinancingCalculator.js" type="text/javascript" />
            </Helmet>
        </React.Fragment>
    );
};
export default MortageRefinancingCalculator;
